import type { AvailabilityConflictKind, CreateManualBookingRequest } from '@/shared/api';
import type { GuestFormValues } from './manualBookingRules';

export function buildManualBookingRequest(args: {
  propertyId: string;
  from: string;
  to: string;
  guest: GuestFormValues;
  nightlyRate: number;
}): CreateManualBookingRequest {
  const { propertyId, from, to, guest, nightlyRate } = args;
  return {
    propertyId,
    checkInDate: from,
    checkOutDate: to,
    adults: guest.adults,
    children: guest.children,
    infants: guest.infants,
    guestFirstName: guest.firstName.trim() || null,
    guestLastName: guest.lastName.trim() || null,
    guestEmail: guest.email.trim() || null,
    guestPhone: guest.phone.trim() || null,
    nightlyRate,
    notes: guest.notes.trim() || null,
  };
}

/** Heute im Kalender des Browsers; `toISOString` hätte abends schon den nächsten Tag (UTC). */
export function todayIso(): string {
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

export function plusDaysIso(base: string, days: number): string {
  const d = new Date(base + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function nightsBetween(from: string, to: string): number {
  const a = new Date(from + 'T00:00:00Z').getTime();
  const b = new Date(to + 'T00:00:00Z').getTime();
  return Math.max(0, Math.round((b - a) / (1000 * 60 * 60 * 24)));
}

export const conflictLabels: Record<AvailabilityConflictKind, string> = {
  BookingOverlap: 'Überschneidung',
  BlockedPeriod: 'Gesperrter Zeitraum',
  MinStay: 'Mindestaufenthalt',
  MaxStay: 'Höchstaufenthalt',
  ClosedToArrival: 'Anreise gesperrt',
  ClosedToDeparture: 'Abreise gesperrt',
  StopSell: 'Verkaufsstopp',
  FlatFamily: 'Wohnungsverbund',
};

const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'short', timeZone: 'UTC' });

/** „Fr 30.10.“ für die Zusammenfassung im Kopf des Panels. */
export function shortDay(iso: string): string {
  const date = new Date(`${iso}T00:00:00Z`);
  return `${weekday.format(date).replace('.', '')} ${date.getUTCDate()}.${date.getUTCMonth() + 1}.`;
}
